var map = {
	"./3isp.gif": 1129,
	"./Customise.png": 3215,
	"./Free.png": 9697,
	"./Main-image.png": 5696,
	"./Quality.png": 9243,
	"./favicon.png": 580,
	"./file_example_png_3mb.png": 8903,
	"./gatsby-astronaut.png": 8262,
	"./group-11549.png": 9794,
	"./landing-5.png": 8737,
	"./linux-icon.png": 3286,
	"./mac-icon.png": 8090,
	"./screenapp-for-coperate-use.png": 8330,
	"./screenapp-for-virtual-learning.png": 8005,
	"./steps/Step-1.svg": 864,
	"./steps/Step-2.svg": 2264,
	"./steps/Step-3.svg": 8718,
	"./steps/Step-4.svg": 4296,
	"./steps/Step-5.svg": 4532,
	"./steps/Step-6.svg": 8520,
	"./steps/Step-7.svg": 4115,
	"./steps/Step-8.svg": 930,
	"./steps/Step-9.svg": 2179,
	"./windows-icon.png": 8618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;